import { IWindow } from '../types/dataLayer';

declare const window: IWindow;

function stripAndTruncate(text: string) {
    const strippedText = text
        .replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '') // Strip HTML
        .replace('\n', ' ')
        .replace(/[ ]{2,}/g, ' '); // Strip two or more spaces

    if (strippedText.length >= 100) {
        return strippedText.slice(0, 100).concat('...');
    }

    return strippedText;
}

export function pushToDataLayer(
    question: string,
    answer: string = '',
    eventCallback?: () => void
) {
    if (!window) return;

    window.dataLayer = window.dataLayer || [];

    const dataLayerEvent = {
        event: 'happyeyescheckEvent',
        eventAction: stripAndTruncate(question),
        eventLabel: answer,
        eventCallback,
    };

    window.dataLayer.push(dataLayerEvent);

    if (process.env.NODE_ENV === 'development' && eventCallback) {
        eventCallback();
    }
}
